import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";

import { FgiBackEndService } from "src/app/shared/fgi-back-end.service";
import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";
import { PatrimonioLiquido } from "src/app/model/patrimonio-liquido.model";
import { HttpParams } from "@angular/common/http";
import { ResultadoPaginado } from "src/app/model/resultado";

export interface NovoPatrimonioLiquidoDTO {
    id: number;
    dataBase: string;
    valor: number;
}

export interface InfoPatrimonioLiquido {
    nome: string,
    valor: number,
    ultimaDataBase: Date,
    dataRegistro: Date,
}

@Injectable({
    providedIn: 'root'
})
export class PatrimonioLiquidoService extends FgiBackEndService<PatrimonioLiquido>{

    getNewEntity(): PatrimonioLiquido {
        return new PatrimonioLiquido();
    }

    protected getResourceURL(): string {
        return 'front/patrimonioLiquido';
    }

    salvar(novoPatrimonioLiquido: NovoPatrimonioLiquidoDTO) {
      const options = blockUi();
      return this.http.post(`${this.BASE_URL}/salvar`, novoPatrimonioLiquido, options).pipe(
        catchError((e) => this.handleError(e))) as Observable<any>;
    }

    getInfoPatrimonioLiquido(id: number) {
        let params = new HttpParams();
        if (id) {
            params = params.append('id', id);
        }
        return this.http.get(`${this.BASE_URL}/informacaoPatrimonioLiquido`, {params: params}).pipe(
            catchError((e) => this.handleError(e))) as Observable<InfoPatrimonioLiquido>;
    }

    getPatrimoniosLiquidos(params?: any): Observable<ResultadoPaginado<PatrimonioLiquido>> {
      return this.http.get(`${this.BASE_URL}/`, {params: params}).pipe(
          catchError((e) => this.handleError(e))) as Observable<ResultadoPaginado<PatrimonioLiquido>>;
    }


}
